import React from 'react'
import {connect} from 'react-redux'
import {toggleNavDropdown} from '../../../redux/modules/ui'
import {getLogout} from '../../../redux/modules/session'
import {SessionDefaultUserPicture} from '../default-user-picture/DefaultUserPicture'
import {UniLink} from '../unilink/index'
import Box from '../box/Box'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

/*function isHidden(el) {
  var style = window.getComputedStyle(el)
  return (style.display === 'none')
}*/
class LoggedInOptionsComponent extends React.PureComponent {
  button = null;
  timeout = null;
  constructor(props) {
    super(props)
    this.state = {
      timeoutActive: false,
    }

    this.hideOptions = this.hideOptions.bind(this)

  }
  componentWillUnmount() {
    window.clearTimeout(this.timeout)
  }

  hideOptions(e) {
    const {hideDropdown} = this.props
    if (!this.state.timeoutActive) {
      hideDropdown(e)
    }
  }

  render () {
    const {
      isModerator,
      userId,
      toggleDropdown,
      dropdownToggled,
      logout
    } = this.props
    const dropdownClassNames = ['logged-in-options__dropdown']
    if (dropdownToggled) {
      dropdownClassNames.push('logged-in-options__dropdown--active')
    }
    return (
      <Box display='flex' alignItems='center'>
        <Box display='none' mdDisplay='inlineBlock' mdMarginRight={12}>
          <UniLink to={`/user/${userId}/edit`} navLink activeStyle={{fontWeight: '600'}}>Settings</UniLink>
        </Box>
        <div
          className="logged-in-options" >
          <button
            className="logged-in-options__button"
            ref={node => this.button = node}
            onMouseDown={(e) => {
              toggleDropdown(!dropdownToggled)
              // Hack to fix event ordering on Safari.
              // Otherwise, dropdown can't be toggled by clicking on the icon again
              this.setState({
                timeoutActive: true
              })
              this.timeout = window.setTimeout(()=> {
                this.setState({timeoutActive: false})
                this.button.focus()
              },100)
            }}
            onBlur={this.hideOptions}
            tabIndex="0"
          >
            <SessionDefaultUserPicture className='logged-in-options__image' />
            <FontAwesomeIcon icon={['fa', 'angle-down']} />
          </button>
          <div className={dropdownClassNames.join(' ')}>
            <UniLink to="/" className="logged-in-options__option" tabIndex="0">
              <FontAwesomeIcon icon={['fa', 'home']} className="logged-in-options__icon" /> Home
            </UniLink>
            {
              isModerator ? (
                <UniLink to="/dashboard" className="logged-in-options__option" tabIndex="0">
                  <FontAwesomeIcon icon={['fa', 'dungeon']} className="logged-in-options__icon" /> Dashboard
                </UniLink>

                ):''
            }

            <Box mdDisplay='none'>
              <div className="logged-in-options__separator" />
              <UniLink to={`/subjects`} className="logged-in-options__option" tabIndex="0">
                <FontAwesomeIcon icon={['fa', 'th-large']} className="logged-in-options__icon" /> Subjects
              </UniLink>
              <UniLink to={`/user/${userId}/edit`} className="logged-in-options__option" tabIndex="0">
                <FontAwesomeIcon icon={['fa', 'cog']} />
                Settings
              </UniLink>
            </Box>
            <div className="logged-in-options__separator" />
            <UniLink onClick={logout} className="logged-in-options__option" tabIndex="0">
              <FontAwesomeIcon icon={['fa', 'sign-out-alt']} className="logged-in-options__icon" /> Log out
            </UniLink>
          </div>
        </div>
      </Box>
    )
  }

}

const mapStateToPropsLoggedInOptions = state => {
  const role = state.getIn(['session', 'user', 'role'])
  return {
    userId: state.getIn(['session', 'user', 'id']),
    isModerator: (role == 'mod' || role == 'admin'),
    profilePictureUrl: state.getIn(['session', 'user', 'profilePicture']),
    dropdownToggled: state.getIn(['ui', 'dropdownIsToggled'])
  }
}
const mapDispatchToPropsLoggedInOptions = dispatch => {
  return {
    logout: () => dispatch(getLogout()),
    toggleDropdown: isOn => dispatch(toggleNavDropdown(isOn)),
    hideDropdown: e => {
      if (e && e.relatedTarget) {
        e.relatedTarget.click()
      }
      dispatch(toggleNavDropdown(false))
    }
  }
}
const LoggedInOptions = connect(
  mapStateToPropsLoggedInOptions,
  mapDispatchToPropsLoggedInOptions
)(LoggedInOptionsComponent)

export default LoggedInOptions



// WEBPACK FOOTER //
// ./src/core/components/navbar/LoggedInOptions.js